import type { FC } from 'react'
import React, { memo } from 'react'
import parse from 'html-react-parser'
import type { IPublicationTextProps } from './types'
import { TRANSFORM_OPTIONS } from './utils'
import './styles.scss'

const PublicationText: FC<IPublicationTextProps> = props => {
  const { html } = props

  if (!html) return null

  return <div className="publicationText">{parse(html, TRANSFORM_OPTIONS)}</div>
}

export default memo(PublicationText)
